import CacheCleaner from "./CacheCleaner"
import CacheManager from "../CacheManager"

export default class SeasonCleaner extends CacheCleaner {

	async onMutation(season_ids, columns) {
		await CacheManager.inst().onObjectsMutation('season', season_ids, columns)
	}
}
